module.exports = __webpack_public_path__ + "img/welcome-1.85dc5d49.png";